

export default {
  
  name: "es_default",
  data(){
    return{
      ready:false
    }
  },
  mounted(){
    setTimeout(()=>{
      this.ready = true;
    },200);
  },
  methods: {
    showItems() {
      if ((Object.keys(this.$route.query) || []).length) {
        return true;
      }
      if(this.$route.path.includes('m.')){
        return true;
      }
      return (
        (Object.keys(this.$store.getters.params) || []).filter(
          (x) => this.$store.getters.params[x]
        ).length >= (this.$store.getters.store.eshop.filtersLevel || 1)
      );
    },
  },
};
